import React from 'react'
import { getEntityReadinessProjects } from '../../helpers/api'
import SectionTableList from './SectionTableList'

const Readiness = props => {

    const { contributor, signalReady } = props

    const [readiness, setReadiness] = React.useState(null)

    React.useEffect(() => {
        getEntityReadinessProjects(contributor.ContributorID)
            .then(data => {
                setReadiness(data)
                signalReady && signalReady('readiness')
            })
    }, [])

    const readinessCols = [
        {
            label: 'ID',
            id: 'RequestID',
            ownRow: true,
            nowrap: true,
            preIcon: 'fa-caret-down'
        },
        {
            label: 'Country'
        },
        {
            label: 'Status'
        },
        {
            label: 'Project Title',
            id: 'ProjectTitle',
            maxLength: 40,
            maxWidth: '200px',
            ownRow: true
        },
        {
            label: 'Region'
        },
        {
            label: 'Delivery Partner',
            id: 'DeliveryPartner'
        },
        {
            label: 'Amount Approved (USD)',
            id: 'AmountApprovedInUSD',
            format: true,
            align: 'right',
            totalize: true
        },
        {
            label: 'Amount Disbursed (USD)',
            id: 'AmountDisbursedInUSD',
            format: true,
            align: 'right',
            totalize: true
        }
    ]

    return (
        <SectionTableList data={readiness} Title='Readiness Projects' Subtitle={`By AEs headquartered in ${contributor.CountryName}`} cols={readinessCols} Total={true} />
    )
}

export default Readiness